<template>
  <div class="card" v-if="model.length > 0">
    <div class="card-body">
      <h4 class="card-title mb-3">Set Permissions</h4>
      <div class="row">
        <div class="col-md-8">
          <div class="form-row form-group">
            <label class="col-md-2 col-form-label">ค้นหา</label>
            <div class="col-md-8">
              <input
                v-model="filter.keyword"
                type="text"
                placeholder="Name / Controller "
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-primary waves-effect"
            @click="onFilter()"
          >
            <i class="bx bx-search font-size-16 align-middle mr-2"></i>
            Search
          </button>
        </div>
      </div>
      <hr />
      <TableView
        :items="model"
        :fields="fields"
        :paginationOptions="paginationOptions"
        @ChangePerPage="onChangePerPage"
        @ClickPagination="onClickPagination"
        small
      >
        <template #cell(checked)="row">
          <b-form-checkbox
            :checked="row.value"
            switch
            @change="onChangeChecked($event, row.item)"
          />
        </template>
        <template #cell(controller)="row">
          <h6>
            {{ row.value }}
            <b-badge variant="light">V{{ row.item.version }}.0</b-badge>
          </h6>
        </template>
      </TableView>
    </div>
  </div>
</template>

<script>
import techProductsService from "@/helpers/service/tech-products-service";
import TableView from "@/components/share/table-view.vue";
export default {
  components: {
    TableView,
  },
  props: {
    techProductId: {
      type: String,
      default: null,
    },
    clientAppsId: {
      type: String,
      default: null,
    },
    techProductClientAppId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      paginationOptions: {
        totalRecords: 0,
        perPage: 25,
        pageNo: 1,
        pageOptions: [10, 25, 50, 100],
      },
      filter: {
        keyword: "",
      },
      model: [],
      techProductPermissions: [],
      techProductClientAppsPermissions: [],
      fields: [
        {
          key: "checked",
          label: "Active",
          thStyle: "width:50px",
          class: "text-center",
        },
        { key: "method", label: "Method", class: "text-center" },
        { key: "display_name", label: "Name", class: "text-center" },
        { key: "controller", label: "Controller", class: "text-center" },
      ],
    };
  },
  mounted() {
    // console.log(this.techProductId);
    // console.log(this.clientAppsId);
    this.onInit();
  },
  methods: {
    async onInit() {
      const techProductId = this.techProductId;
      const clientAppsId = this.clientAppsId;
      if (!techProductId || !clientAppsId) {
        return;
      }
      await this.getTechProductPermissionsAsync();
      await this.getTechProductClientAppsPermissionsAsync();
      this.model = this.techProductPermissions.map((it) => ({
        ...it,
        checked: this.techProductClientAppsPermissions.some(
          (p) => p.permission_info.id === it.id
        ),
      }));
    },
    async onFilter() {
      this.onInit();
    },
    async getTechProductPermissionsAsync() {
      const techProductId = this.techProductId;
      let params = new URLSearchParams();
      params.append("pageNo", this.paginationOptions.pageNo);
      params.append("pageSize", this.paginationOptions.perPage);
      params.append("keyword", this.filter.keyword);
      let result = await techProductsService.getTechProductPermissionsAsync(
        techProductId,
        params
      );
      if (result.status === 200) {
        // console.log(result);
        this.techProductPermissions = result.data.items;
        this.paginationOptions.totalRecords = result.data.totalRecords;
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    async getTechProductClientAppsPermissionsAsync() {
      const techProductId = this.techProductId;
      const clientAppsId = this.clientAppsId;
      let params = new URLSearchParams();
      params.append("pageNo", 1);
      params.append("pageSize", 999);
      let result =
        await techProductsService.getTechProductClientAppsPermissionsAsync(
          techProductId,
          clientAppsId,
          params
        );
      if (result.status === 200) {
        // console.log(result);
        this.techProductClientAppsPermissions = result.data.items;
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    onChangePerPage(perPage) {
      this.paginationOptions.perPage = perPage;
      this.onInit();
    },
    onClickPagination(pageNo) {
      this.paginationOptions.pageNo = pageNo;
      this.onInit();
    },
    onChangeChecked(checked, item) {
      const permissionId = item.id;
      if (checked) {
        this.createServiceClientAppsPermissionAsync(permissionId);
      } else {
        this.deleteServiceClientAppsPermissionAsync(permissionId);
      }
    },
    async createServiceClientAppsPermissionAsync(permission_id) {
      const techProductId = this.techProductId;
      const clientAppsId = this.clientAppsId;
      const model = {
        client_apps_allow_service_id: this.techProductClientAppId,
        permission_id,
      };
      let result =
        await techProductsService.createServiceClientAppsPermissionAsync(
          techProductId,
          clientAppsId,
          model
        );

      if (result.status === 200) {
        // console.log(result);
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    async deleteServiceClientAppsPermissionAsync(permission_id) {
      const techProductId = this.techProductId;
      const clientAppsId = this.clientAppsId;
      let params = new URLSearchParams();
      params.append(
        "client_apps_allow_service_id",
        this.techProductClientAppId
      );
      params.append("permission_id", permission_id);
      let result =
        await techProductsService.deleteServiceClientAppsPermissionAsync(
          techProductId,
          clientAppsId,
          params.toString()
        );

      if (result.status === 200) {
        // console.log(result);
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
  },
};
</script>

<style lang="css" scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
